import React from 'react'
import {
    SswSubscriptionPackage,
    SswSubscriptionPrice,
} from '@news-mono/web-common'
import {
    StyledDashedRule,
    StyledMiniPackageHeader,
    StyledMiniSubscriptionPackage,
    StyledMiniSubscriptionPackageBenefit,
} from './MiniSubscriptionPackage.styled'
import { SubscriptionPackageBenefit } from './SubscriptionPackageBenefit'
import { StyledMiniPackageImage } from './SubscriptionPackage.styled'

export interface MiniSubscriptionPackageProps {
    subscriptionPackage: SswSubscriptionPackage
    pricePackage: SswSubscriptionPrice
    imagePath: string
}

export const MiniSubscriptionPackage = ({
    subscriptionPackage,
    pricePackage,
    imagePath,
}: MiniSubscriptionPackageProps) => {
    const { heading, benefitOverride } = subscriptionPackage
    const weeklyPrice = pricePackage.weeklyPrice
    const promoPrice = pricePackage.promoPrice
    const hasPromoPrice = promoPrice && promoPrice > 0
    const currentPrice = hasPromoPrice ? promoPrice : weeklyPrice

    return (
        <StyledMiniSubscriptionPackage>
            <StyledMiniPackageImage
                src={imagePath}
                alt={heading ?? 'Subscription Package Image'}
            />
            <StyledMiniPackageHeader>
                {hasPromoPrice && (
                    <span className="original-price">{pricePackage.price}</span>
                )}
                <h4>{heading}</h4>
                {currentPrice ? (
                    <span>
                        $
                        {currentPrice.toFixed(
                            Number.isInteger(currentPrice) ? 0 : 2,
                        )}
                        / <span>week</span>
                    </span>
                ) : (
                    <span></span>
                )}
            </StyledMiniPackageHeader>
            <StyledDashedRule />

            {benefitOverride?.map((feature) => (
                <SubscriptionPackageBenefit
                    benefit={{
                        name: feature,
                        isAvailable: true,
                    }}
                    containerComponent={StyledMiniSubscriptionPackageBenefit}
                    key={feature}
                    packageOptions={undefined}
                    breachOptions={undefined}
                />
            ))}
            {pricePackage.additionalBenefits?.map((feature) => (
                <SubscriptionPackageBenefit
                    benefit={{
                        name: feature,
                        isAvailable: false,
                    }}
                    containerComponent={StyledMiniSubscriptionPackageBenefit}
                    key={feature}
                    packageOptions={undefined}
                    breachOptions={undefined}
                />
            ))}
        </StyledMiniSubscriptionPackage>
    )
}

export type SubscriptionPackageFeatureValue = {
    name: string
    isAvailable: boolean
}
